import sumBy from 'lodash/sumBy.js';

import Course from '@/models/Course.js';
import Model from '@/models/Model.js';
import QueryBuilder from '@/utilities/QueryBuilder.js';

export default class EnrollmentGroup extends Model {
    static entity = 'enrollment_groups';

    static loadedForCourses = [];

    static fields() {
        return {
            id: this.attr(null),
            course_id: this.attr(null),
            external_id: this.attr(null),
            title: this.attr(null),
            color_id: this.attr(null),
            course_enrollments_count: this.attr(null),
            time_periods_count: this.attr(null),

            ...super.fields(),

            course: this.belongsTo('courses', 'course_id'),
            course_enrollments: this.belongsToMany(
                'course_enrollments',
                'course_enrollment_enrollment_group',
                'enrollment_group_id',
                'course_enrollment_id'
            ),
            time_periods: this.belongsToMany(
                'time_periods',
                'enrollment_group_time_period',
                'enrollment_group_id',
                'time_period_id'
            ),
            color: this.belongsTo('enrollment_group_colors', 'color_id'),
        };
    }

    static searchable() {
        return ['title'];
    }

    static loadForCourse(courseId) {
        if (this.loadedForCourses.includes(courseId)) {
            return Promise.resolve(null);
        }

        this.loadedForCourses.push(courseId);

        const query = new QueryBuilder('enrollment-groups')
            .filter('course_id', courseId)
            .include(['courseEnrollmentsCount', 'timePeriodsCount']);

        return EnrollmentGroup.api().get(query.toUrl());
    }

    static resetTimePeriodCounts() {
        EnrollmentGroup.query()
            .with('time_periods')
            .get()
            .forEach(enrollmentGroup =>
                enrollmentGroup.$update({
                    time_periods_count: enrollmentGroup.time_periods.length,
                })
            );
    }

    get scheduled_time() {
        const enrollmentGroupTimes = Course.scheduled_time(this.time_periods);
        const courseTimes = this.course.ungrouped_scheduled_time;

        return {
            total_minutes: sumBy([enrollmentGroupTimes, courseTimes], 'total_minutes'),
            total_break_minutes: sumBy([enrollmentGroupTimes, courseTimes], 'total_break_minutes'),
            hours: sumBy([enrollmentGroupTimes, courseTimes], 'hours'),
            minutes: sumBy([enrollmentGroupTimes, courseTimes], 'minutes'),
            break_hours: sumBy([enrollmentGroupTimes, courseTimes], 'break_hours'),
            break_minutes: sumBy([enrollmentGroupTimes, courseTimes], 'break_minutes'),
        };
    }

    get style() {
        return this.color ? this.color.style : {};
    }

    get has_issue() {
        return !this.pivot.check_in_code || !this.pivot.course_key_id;
    }
}
